import React from 'react';
import _ from 'lodash';
import Loader from '../../../components/Loader';
import {
  fetchCoaches, createAndInviteCoach, updateCoach,
} from '../../../api/coaches';
import useAdminDataManager from '../../../hooks/useAdminDataManager';
import {
  Section,
} from "../../../components/styled";
import { CoachDialog, AddCoachButton, CoachList } from "../../../components/pages/coaches"
import { withRouter } from "react-router-dom";


export default withRouter(({ history }) => {
  const { manage, state } = useAdminDataManager(fetchCoaches, createAndInviteCoach, updateCoach, {archived: false});
  const {
    cancelEdit, startEdit, startCreate, saveData,
  } = manage;

  const { currentMode, items, targetItem } = state;
  const renderByMode = {
    loading: () => <Loader />,
    editing: () => <CoachDialog onCancel={cancelEdit} onSave={saveData} initialState={targetItem} />,
    listing: () => (
      <>
        {startCreate && (
          <Section>
            <AddCoachButton onClick={startCreate} />
          </Section>
        )}

        <Section>
          <CoachList coaches={_.orderBy(items, org => (org.name || "").toUpperCase())} onEdit={startEdit} history={history} isAdmin={true} />
        </Section>
      </>
    ),
  };
  return (
    <>
      <h2> Coaches </h2>
      {renderByMode[currentMode]()}
    </>
  );
});
